(() => {
  const updateCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-ro-cart-count]').forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count < 1;
      });
      document.querySelectorAll('[data-ro-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', `Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
      });
    } catch (_) {
      // Keep Liquid-rendered count when the cart endpoint is unavailable.
    }
  };

  window.addEventListener('pageshow', updateCartCount);
  ['cart:update', 'cart:refresh', 'cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, updateCartCount);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('button[name="add"], [data-add-to-cart], .quick-add__button')) {
      window.setTimeout(updateCartCount, 500);
      window.setTimeout(updateCartCount, 1400);
    }
  });

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const result = await originalFetch(...args);
    const target = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(target)) {
      window.setTimeout(updateCartCount, 80);
    }
    return result;
  };
})();
